import React, { useCallback } from 'react';
import { Radio } from 'antd';
import LookupField from '../../../components/LookupField';
import type { FP620 } from '../../../services/pwp252Api';

interface Tab1BasicInfoProps {
  formData: Partial<FP620>;
  isEditing: boolean;
  onChange: (field: keyof FP620, value: any) => void;
}

const Tab1BasicInfo: React.FC<Tab1BasicInfoProps> = ({ formData, isEditing, onChange }) => {
  const ro = !isEditing;

  const handleScNoConfirm = useCallback((code: string) => {
    onChange('fp620_10', code);
  }, [onChange]);

  const handleProductConfirm = useCallback((code: string) => {
    onChange('fp620_29', code);
  }, [onChange]);

  const handleCustomerConfirm = useCallback((code: string) => {
    onChange('fp620_17', code);
  }, [onChange]);

  return (
    <div className="pwp252-tab1">
      <div className="pwp252-field-row">
        <label>單據號碼</label>
        <input
          type="text"
          value={formData.fp620_01 || ''}
          readOnly
          disabled
          className="pwp252-input"
          placeholder="自動產生"
        />
      </div>

      <div className="pwp252-field-row">
        <label><span className="required">*</span>日    期</label>
        <input
          type="date"
          value={formData.fp620_11 ? formData.fp620_11.substring(0, 10) : ''}
          readOnly={ro}
          onChange={e => onChange('fp620_11', e.target.value ? new Date(e.target.value).toISOString() : null)}
          className="pwp252-input"
        />
      </div>

      <div className="pwp252-field-row">
        <label><span className="required">*</span>S/C NO.</label>
        <LookupField
          lookupType="salesContract"
          value={formData.fp620_10 || ''}
          onChange={v => onChange('fp620_10', v)}
          onCodeConfirm={handleScNoConfirm}
          disabled={ro}
          maxLength={6}
          style={{ width: 200 }}
        />
      </div>

      <div className="pwp252-field-row">
        <label>產品代號</label>
        <LookupField
          lookupType="product"
          value={formData.fp620_29 || ''}
          onChange={v => onChange('fp620_29', v)}
          onCodeConfirm={handleProductConfirm}
          disabled={ro}
          maxLength={12}
          style={{ width: 200 }}
        />
      </div>

      <div className="pwp252-field-row">
        <label>SHIPPING MARK</label>
        <textarea
          value={formData.fp620_13 || ''}
          readOnly={ro}
          onChange={e => onChange('fp620_13', e.target.value)}
          className="pwp252-textarea"
          rows={3}
        />
      </div>

      <div className="pwp252-field-row">
        <label><span className="required">*</span>DESCRIPTION OF GOODS</label>
        <textarea
          value={formData.fp620_14 || ''}
          readOnly={ro}
          onChange={e => onChange('fp620_14', e.target.value)}
          className="pwp252-textarea"
          rows={3}
        />
      </div>

      <div className="pwp252-field-row">
        <label>CONTAINER NO.</label>
        <input
          type="text"
          value={formData.fp620_15 || ''}
          readOnly={ro}
          maxLength={20}
          onChange={e => onChange('fp620_15', e.target.value)}
          className="pwp252-input"
        />
      </div>

      <div className="pwp252-field-row">
        <label>材        積</label>
        <input
          type="text"
          value={formData.fp620_16 || ''}
          readOnly={ro}
          maxLength={50}
          onChange={e => onChange('fp620_16', e.target.value)}
          className="pwp252-input"
        />
      </div>

      <div className="pwp252-field-row">
        <label>客戶代號</label>
        <LookupField
          lookupType="packingCustomer"
          value={formData.fp620_17 || ''}
          onChange={v => onChange('fp620_17', v)}
          onCodeConfirm={handleCustomerConfirm}
          disabled={ro}
          maxLength={12}
          style={{ width: 200 }}
        />
      </div>

      <div className="pwp252-field-row">
        <label><span className="required">*</span>出貨單位</label>
        <Radio.Group
          value={formData.fp620_25 || 1}
          disabled={ro}
          onChange={e => onChange('fp620_25', e.target.value)}
        >
          <Radio value={1}>YDS</Radio>
          <Radio value={2}>MTS</Radio>
          <Radio value={3}>PCS</Radio>
        </Radio.Group>
      </div>

      {/* 針織/平織 — only shown when not PCS */}
      {formData.fp620_25 !== 3 && (
        <div className="pwp252-field-row">
          <label><span className="required">*</span>針織/平織</label>
          <Radio.Group
            value={formData.fp620_28 || 1}
            disabled={ro}
            onChange={e => onChange('fp620_28', e.target.value)}
          >
            <Radio value={1}>針織</Radio>
            <Radio value={2}>平織</Radio>
          </Radio.Group>
        </div>
      )}

    </div>
  );
};

export default Tab1BasicInfo;
